window.onscroll = function () {
    scrollFunction()
};

function scrollFunction() {
    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
        $('.menu-top').addClass('is-fixed')
    } else {
        $('.menu-top').removeClass('is-fixed')
    }
}

$(document).ready(function () {
    function adjustStyle() {
        let menuContainer = $('.row.mobile-hidden');
        let height = menuContainer.height() - 47;
        menuContainer.css('margin-top', - height)
        let toggled = false;
        
        $('#nav-burger').click(function () {
            if (!toggled) {
                menuContainer.css('margin-top', '0')
                toggled = true;
            } else {
                menuContainer.css('margin-top', - height)
                toggled = false;
            }
        });
    }

    if(window.matchMedia("(max-width:768px)").matches) {
        adjustStyle();
    }

    window.onresize = function () {
        if(window.matchMedia("(max-width:768px)").matches) {
            adjustStyle();
        }
    };
});